/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { CompleteIcon } from "../../../shared/CompleteIcon";
import { useContext } from "../../../context";

export function Questionnaires() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Questionnaire(s):</label>
      <span>
        <CompleteIcon isCompleted={appointment.isQuestionnairesCompleted} />
      </span>
    </div>
  );
}
